import { Flavor } from "./types";

export const viewport = {
  sm: "36em",
  md: "48em",
  lg: "62em",
  xl: "75em"
};

export const sections = {
  height: {
    landing: 100, //vh
    buffer: 60,
    history: 100,
    faqs: 100,
    flavor: 150,
    contact: 100
  },
  width: {
    xs: 90, //vw
    md: 80,
    xl: 75
  }
}

export const cider = {
  position: {
    // origin: { x: 0, y: 0 },
    range: {
      xs: { x: 1.35, y: 2.25 },
      sm: { x: 2.0, y: 2.25 },
      md: { x: 2.3, y: 2.25 },
      lg: { x: 2.8, y: 2.25 },
      xl: { x: 3.0, y: 2.25 }
    }
  },
  scale: {
    xs: 1.0,
    sm: 1.1,
    md: 1.1,
    lg: 1.2,
    xl: 1.2
  }
};